// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import type { RequestStates } from 'types/redux';
import { Dropdown } from 'semantic-grab-ui/src';
import _ from 'lodash';
import { hasJustSuccess } from 'utils/request-state-utils';
import { getApprovers } from 'actions/newTridentExtra';

type Props = {
  onChange: Function,
  getApprovers: Function,
  approvers: Array,
  getApproversRequest: RequestStates,
  excludeList: Array, // array of users to exclude from the approver selection
};

// ApproverSelectionInput lets user select a user email as approver
class ApproverSelectionInput extends Component {
  props: Props;

  constructor(props: Props) {
    super(props);
    this.state = {
      options: [],
      value: [],
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    if (hasJustSuccess(this.props.getApproversRequest, nextProps.getApproversRequest)) {
      const approvers = _.filter(nextProps.approvers, u => !_.includes(this.props.excludeList, u.email));
      const options = _.map(approvers, u => {
        return {
          key: u.email,
          text: u.email,
          value: u.email,
        };
      });
      const selected = _.map(this.state.value, v => {
        return { key: v, text: v, value: v };
      });
      this.setState({
        options: [...selected, ...options],
      });
    }
  }

  onValueChange = (event: any, data: any) => {
    this.setState({
      value: data.value,
    });
    this.props.onChange(event, data);
  };

  onSearchChange = _.throttle((event: any, data: any) => {
    // call endpoint to search
    this.props.getApprovers({
      q: data.searchQuery,
      page: 0,
      pageSize: 100,
    });
  }, 1000);

  render() {
    return (
      <Dropdown
        placeholder="e.g. abc@grabtaxi.com"
        search
        selection
        multiple
        options={this.state.options}
        value={this.state.value}
        onChange={this.onValueChange}
        onSearchChange={this.onSearchChange}
      />
    );
  }
}


export function mapStateToProps(state: StoreState) {
  return {
    approvers: _.get(state, 'newTridents.approvers', []),
    getApproversRequest: _.get(state.requests, 'getApproversRequest', {}),
  };
}

export default connect(mapStateToProps, {
  getApprovers,
})(ApproverSelectionInput);
